export default __webpack_public_path__ + "static/media/detail_mobile_5_5.e65b2b97.png";